var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8085 6.646L8.16211 12.2925L5.69141 9.82275C5.68903 9.82037 5.68665 9.81799 5.6842 9.81561C5.487 9.62238 5.17047 9.62555 4.97723 9.82275C4.78394 10.02 4.78717 10.3365 4.98438 10.5298L7.80859 13.353C7.90222 13.447 8.02948 13.4997 8.16211 13.4995C8.29474 13.4996 8.42194 13.447 8.51556 13.353L14.5156 7.35303C14.5179 7.35065 14.5203 7.34833 14.5227 7.34589C14.7159 7.14868 14.7128 6.83215 14.5156 6.63892C14.3184 6.44562 14.0018 6.44885 13.8085 6.646ZM10 -0.000488281C4.47717 -0.000488281 0 4.47668 0 9.99951C0 15.5223 4.47717 19.9995 10 19.9995C15.5201 19.993 19.9935 15.5197 20 9.99951C20 4.47668 15.5228 -0.000488281 10 -0.000488281ZM10 18.9995C5.02942 18.9995 1 14.9701 1 9.99951C1 5.02893 5.02942 0.999512 10 0.999512C14.9683 1.00494 18.9946 5.03119 19 9.99951C19 14.9701 14.9706 18.9995 10 18.9995Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check-circle-outline.e19dd71abaff0d5c81dbb568424d107e.svg";
export { ForwardRef as ReactComponent };